<div class="p-l-3 p-r-4 p-r-3-s p-b-5 p-t-5">

  <p class="p1 block p-b-5">{{'Sort by' | translate}}</p>

  <div class="overflow-x-auto no-wrap p-b-3"
    *ifSize="'SM'">
    @for (option of sort.getOptions(); track option; let index = $index; let isLast = $last) {
      <button type="button"
        class="sort-option inline-block p2 bg-col-51 p-r-2 p-l-2 b-a "
        (click)="select(option, index);"
        [class.m-r-2]="!isLast"
        [class.b-col-1]="option.active"
        [class.b-col-t]="!option.active">
        {{option.label}}
      </button>
    }
  </div>


  <div *ifSize="'XL'">
    <carousel class="block sort-options"
      [slidesPerView]="'auto'"
      [navigation]="false"
      [spaceBetween]="8"
      (afterInit)="onAfterInit($event)"
      [loop]="false">
      @for (option of sort.getOptions(); track option; let index = $index; let isLast = $last) {
        <ng-template swiperSlide>
          <button type="button"
            class="sort-option inline-block p2 bg-col-51 p-r-2 p-l-2 b-a "
            (click)="select(option, index);"
            [class.b-col-1]="option.active"
            [class.b-col-t]="!option.active">
            {{option.label}}
          </button>
        </ng-template>
      }
    </carousel>
  </div>
</div>
